// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__SlrOJ","avatar":"style_avatar__gxK7n"};